module.exports = __webpack_public_path__ + "media/images/pc/specials/common/recommend_furano-b6fb56ae561fdad7cf753cbfe77c2964.jpg";